import React, { FunctionComponent } from 'react';
import { TitleTextModel } from '../../models/navigationItem.model';
import { Text } from '@sitecore-jss/sitecore-jss-react';

const TitleText: FunctionComponent<{ model: TitleTextModel }> = ({ model }) => {
  const headerTitleClass = model.title.value? 'navigation-link navigation-link--title' : 'navigation-link navigation-link--title placeholder'
  return (
    <span className={headerTitleClass}>
      <Text field={model.title}  tag="span" />
    </span>
  );
};

export default TitleText;
